module.exports = __webpack_public_path__ + "img/7_199.142849d3.png";